import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import AdBanner from '../components/AdBanner';
import './HomePage.css';

function HomePage() {
  return (
    <div className="home-page">
      <SEO
        title="AI 로또 번호 추천 - 인공지능 로또 예측 + 오늘의 운세 | 로또운세"
        description="AI 로또 번호 추천! 인공지능이 분석한 오늘의 로또 번호와 GPT AI 운세를 무료로 확인하세요. AI 추천 로또 번호, 행운의 숫자, 별자리, 띠, 타로 운세까지!"
        keywords="AI 로또 번호 추천, AI 추천 로또 번호, AI 로또번호, 인공지능 로또, 인공지능 로또 번호 추천, AI 로또 예측, AI 로또 분석, GPT 로또, 챗GPT 로또, 오늘 로또 번호 추천, 로또운세, 로또 운세, 오늘의 로또 번호, 오늘의 행운의 숫자, AI 운세, 인공지능 운세, AI 행운의 숫자"
        url="https://lottounse.kr"
      />
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="title-line">🎰 AI 로또 번호 추천</span>
            <span className="title-separator"> + </span>
            <span className="title-line">🔮 오늘의 운세</span>
          </h1>
          <p className="hero-subtitle">
            인공지능 AI가 분석한 오늘의 로또 번호 추천과 행운의 숫자, 매일 업데이트되는 GPT AI 운세를 한 곳에서
          </p>
          <div className="hero-buttons">
            <Link to="/lotto" className="hero-btn primary">
              로또 번호 생성하기
            </Link>
            <Link to="/fortune" className="hero-btn secondary">
              오늘의 운세 보기
            </Link>
          </div>
        </div>
      </section>

      <AdBanner />

      {/* Features Section */}
      <section className="features">
        <h2 className="section-title">주요 기능</h2>
        <div className="features-grid">
          {/* Lotto Feature */}
          <Link to="/lotto" className="feature-card">
            <div className="feature-icon">🎰</div>
            <h3>AI 로또 번호 추천</h3>
            <p>인공지능 AI 7가지 모델로 번호 생성</p>
            <ul className="feature-list">
              <li>랜덤 생성</li>
              <li>통계 기반 분석</li>
              <li>패턴 인식</li>
              <li>핫&콜드 넘버</li>
            </ul>
          </Link>

          {/* Chinese Zodiac */}
          <Link to="/fortune/chinese" className="feature-card">
            <div className="feature-icon">🐭</div>
            <h3>12띠 운세</h3>
            <p>띠별 오늘의 운세</p>
            <ul className="feature-list">
              <li>총운</li>
              <li>애정운</li>
              <li>금전운</li>
              <li>건강운</li>
            </ul>
          </Link>

          {/* Zodiac Fortune */}
          <Link to="/fortune/zodiac" className="feature-card">
            <div className="feature-icon">♈</div>
            <h3>12별자리 운세</h3>
            <p>오늘의 별자리별 운세</p>
            <ul className="feature-list">
              <li>총운</li>
              <li>애정운</li>
              <li>금전운</li>
              <li>건강운</li>
            </ul>
          </Link>

          {/* Tarot */}
          <Link to="/fortune/tarot" className="feature-card">
            <div className="feature-icon">🃏</div>
            <h3>타로 카드</h3>
            <p>오늘의 타로 메시지</p>
            <ul className="feature-list">
              <li>메이저 아르카나 22장</li>
              <li>카드별 의미</li>
              <li>오늘의 조언</li>
              <li>행운 정보</li>
            </ul>
          </Link>

          {/* Dream Interpretation */}
          <Link to="/fortune/dream" className="feature-card">
            <div className="feature-icon">🌙</div>
            <h3>꿈해몽</h3>
            <p>AI가 분석하는 꿈 해석</p>
            <ul className="feature-list">
              <li>8개 꿈 카테고리</li>
              <li>자유 입력 해몽</li>
              <li>길흉 판단</li>
              <li>행운 번호</li>
            </ul>
          </Link>

          {/* Lucky Numbers */}
          <Link to="/fortune/lucky" className="feature-card">
            <div className="feature-icon">🍀</div>
            <h3>오늘의 행운</h3>
            <p>AI 행운의 숫자와 색깔</p>
            <ul className="feature-list">
              <li>행운의 숫자 6개</li>
              <li>행운의 색깔</li>
              <li>행운의 방향</li>
              <li>행운의 아이템</li>
            </ul>
          </Link>

          {/* Statistics */}
          <Link to="/stats" className="feature-card">
            <div className="feature-icon">📊</div>
            <h3>통계 분석</h3>
            <p>로또 당첨 번호 통계</p>
            <ul className="feature-list">
              <li>번호별 출현 빈도</li>
              <li>최근 트렌드</li>
              <li>차트 분석</li>
              <li>1,200+ 회차 데이터</li>
            </ul>
          </Link>
        </div>
      </section>

      <AdBanner />

      {/* Info Section */}
      <section className="info-section">
        <div className="info-box">
          <h3>💡 이용 안내</h3>
          <p>
            로또운세는 인공지능 AI가 매일 분석하는 로또 번호 추천과 오늘의 운세 숫자를 제공합니다.
            GPT AI가 추천하는 오늘의 행운의 숫자와 AI 로또 예측을 확인하세요.
            매주 토요일 최신 로또 당첨 번호를 자동 업데이트하고,
            매일 새벽 3시에 새로운 운세를 생성합니다.
          </p>
        </div>

        <div className="info-box warning">
          <h3>⚠️ 주의사항</h3>
          <p>
            본 서비스는 재미와 참고용으로만 사용하시기 바랍니다.
            로또 당첨을 보장하지 않으며, 운세는 오락 및 재미 목적입니다.
            과도한 로또 구매는 경제적 어려움을 초래할 수 있습니다.
          </p>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
